<script>
    import { onMount, onDestroy } from "svelte";
    import { switchPage } from "../store";

    export let backgroundImage;

    onMount(() => {
        let vh = window.innerHeight * 0.01;

        document.documentElement.style.setProperty("--vh", `${vh}px`);

        window.addEventListener("resize", () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
        });

        document.body.style.overflow = "hidden";
        document.body.style.height = "100vh";
    });

    onDestroy(() => {
        document.documentElement.style = "";
        document.body.style.overflow = "";
    });

    let bgImageTemplate = `background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url("${backgroundImage}");`;
</script>

<style>
    .container {
        height: 100vh;
        /* Use vh as a fallback for browsers that do not support Custom Properties */
        height: calc(var(--vh, 1vh) * 100);
        margin: 0 auto;
        max-width: 100%;
        user-select: none;
        background-image: none;
    }
</style>

<div class="container" style={bgImageTemplate}>
    <div id="2nd" class="section how">
        <div class="turn-on-the-sound">
            <div class="turn-on-the-sound-icon">
                <div class="sound-on-icon w-embed">
                    <svg
                        class="w-6 h-6"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            fill-rule="evenodd"
                            d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828 1 1 0 010-1.415z"
                            clip-rule="evenodd" />
                    </svg>
                </div>
            </div>
            <h3 class="paragraph">Не забудьте включить звук!<br /></h3>
        </div>
        <div class="wrap-rules centerd">
            <h3 class="paragraph subheadline centered">
                Ловите только ноты и ничего больше.<br />Не расслабляйтесь: пока
                звучит мелодия, игра не окончена.<br />
            </h3>
            <div class="note-container">
                <div class="note-wrap">
                    <img
                        src="images/jazz_note.png"
                        loading="lazy"
                        alt=""
                        class="image" />
                    <div class="like w-embed">
                        <svg
                            width="100%"
                            height="100%"
                            version="1.1"
                            id="Capa_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            viewBox="0 0 512 512"
                            fill="white">
                            <g>
                                <g>
                                    <path
                                        d="M469.51,317c7.14-7.97,11.49-18.49,11.49-30c0-24.81-20.19-45-45-45h-87.34c8.65-26.25,12.34-61.08,12.34-76.01V151
			c0-33.08-26.92-60-60-60h-15c-6.88,0-12.88,4.68-14.55,11.36l-8.17,32.69c-11.45,45.78-47.8,96.29-85.42,105.47
			C171.27,223.84,155,212,136,212H46c-8.28,0-15,6.72-15,15v270c0,8.28,6.72,15,15,15h90c17.89,0,33.37-10.49,40.62-25.65
			l51.54,17.18c16.85,5.62,34.41,8.47,52.18,8.47H406c24.81,0,45-20.19,45-45c0-5.85-1.12-11.45-3.16-16.58
			C466.92,445.21,481,427.72,481,407c0-11.51-4.35-22.03-11.49-30c7.14-7.97,11.49-18.49,11.49-30S476.65,324.97,469.51,317z
			 M151,467c0,8.27-6.73,15-15,15H61V242h75c8.27,0,15,6.73,15,15V467z M406,332h30c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15h-30
			c-8.28,0-15,6.72-15,15c0,8.28,6.72,15,15,15h30c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15h-30c-8.28,0-15,6.72-15,15
			c0,8.28,6.72,15,15,15c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15H280.34c-14.54,0-28.91-2.33-42.7-6.93L181,456.19V270.58
			c23.53-4.47,46.56-19.37,67.35-43.76c20.3-23.82,36.76-55.4,44.03-84.49l5.33-21.33H301c16.54,0,30,13.46,30,30v14.99
			c0,20.14-6.3,58.77-14.36,76.01H286c-8.28,0-15,6.72-15,15c0,8.28,6.72,15,15,15h150c8.27,0,15,6.73,15,15c0,8.27-6.73,15-15,15
			h-30c-8.28,0-15,6.72-15,15C391,325.28,397.72,332,406,332z" />
                                </g>
                            </g>
                            <g>
                                <g>
                                    <circle cx="106" cy="437" r="15" />
                                </g>
                            </g>
                            <g>
                                <g>
                                    <path
                                        d="M316,0c-8.284,0-15,6.716-15,15v31c0,8.284,6.716,15,15,15s15-6.716,15-15V15C331,6.716,324.284,0,316,0z" />
                                </g>
                            </g>
                            <g>
                                <g>
                                    <path
                                        d="M252.36,66.148l-21.213-21.213c-5.857-5.858-15.355-5.858-21.213,0c-5.858,5.858-5.858,15.355,0,21.213l21.213,21.213
			c5.857,5.857,15.356,5.858,21.213,0C258.218,81.503,258.218,72.006,252.36,66.148z" />
                                </g>
                            </g>
                            <g>
                                <g>
                                    <path
                                        d="M422.066,44.935c-5.857-5.858-15.355-5.858-21.213,0L379.64,66.147c-5.858,5.858-5.858,15.355,0,21.213
			c5.857,5.858,15.355,5.859,21.213,0.001l21.213-21.213C427.924,60.29,427.924,50.793,422.066,44.935z" />
                                </g>
                            </g>
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                        </svg>
                    </div>
                </div>
                <div class="note-wrap _2">
                    <img
                        src="images/jazz_note_bad.png"
                        loading="lazy"
                        alt=""
                        class="image" />
                    <div class="like w-embed">
                        <svg
                            width="100%"
                            height="100%"
                            version="1.1"
                            id="Capa_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            x="54px"
                            y="54px"
                            viewBox="0 0 512 512"
                            style="enable-background:new 0 0 512 512;"
                            xml:space="preserve"
                            fill="white">
                            <g>
                                <g>
                                    <path
                                        d="M42.5,264c-7.1,8-11.5,18.5-11.5,30c0,24.8,20.2,45,45,45h87.3c-8.6,26.3-12.3,61.1-12.3,76v15c0,33.1,26.9,60,60,60h15
			c6.9,0,12.9-4.7,14.5-11.4l8.2-32.7c11.4-45.8,47.8-96.3,85.4-105.5C340.7,357.2,357,369,376,369h90c8.3,0,15-6.7,15-15V84
			c0-8.3-6.7-15-15-15h-90c-17.9,0-33.4,10.5-40.6,25.6l-51.5-17.2C267,71.9,249.4,69,231.7,69H106c-24.8,0-45,20.2-45,45
			c0,5.9,1.1,11.5,3.2,16.6C45.1,135.8,31,153.3,31,174c0,11.5,4.4,22,11.5,30c-7.1,8-11.5,18.5-11.5,30S35.4,256,42.5,264z
			 M361,114c0-8.3,6.7-15,15-15h75v240h-75c-8.3,0-15-6.7-15-15V114z M106,249H76c-8.3,0-15-6.7-15-15s6.7-15,15-15h30
			c8.3,0,15-6.7,15-15s-6.7-15-15-15H76c-8.3,0-15-6.7-15-15s6.7-15,15-15h30c8.3,0,15-6.7,15-15s-6.7-15-15-15c-8.3,0-15-6.7-15-15
			s6.7-15,15-15h125.7c14.5,0,28.9,2.3,42.7,6.9l56.6,18.9v185.6c-23.5,4.5-46.6,19.4-67.4,43.8c-20.3,23.8-36.8,55.4-44,84.5
			l-5.3,21.3H211c-16.5,0-30-13.5-30-30v-15c0-20.1,6.3-58.8,14.4-76H226c8.3,0,15-6.7,15-15s-6.7-15-15-15H76c-8.3,0-15-6.7-15-15
			s6.7-15,15-15h30c8.3,0,15-6.7,15-15S114.3,249,106,249z" />
                                </g>
                            </g>
                            <g>
                                <g>
                                    <circle cx="406" cy="144" r="15" />
                                </g>
                            </g>
                        </svg>
                    </div>
                </div>
            </div>
            <div
                class="button-hero _300px w-button"
                data-gtm="pognali"
                on:click={() => switchPage('GAME_COUNTDOWN_PAGE')}>
                Погнали!
            </div>
        </div>
    </div>
</div>
